/**
 * @generated SignedSource<<77be0927ccb0399b30f768f5e233eb64>>
 * @relayHash cb4bde4176e81a91b3f1186c570e84aa
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID cb4bde4176e81a91b3f1186c570e84aa

import { ConcreteRequest } from 'relay-runtime';
export type Ch_updateCareProviderInput = {
  email?: string | null;
  id: string;
  isMedgatePartnerNetworkMember: boolean;
  isTakesNewPatients: boolean;
  phoneNumber?: string | null;
  website?: string | null;
};
export type useUpdateCareProviderMutation$variables = {
  input: Ch_updateCareProviderInput;
};
export type useUpdateCareProviderMutation$data = {
  readonly ch_updateCareProvider: {
    readonly careProvider: {
      readonly id: string;
    } | null;
  };
};
export type useUpdateCareProviderMutation = {
  response: useUpdateCareProviderMutation$data;
  variables: useUpdateCareProviderMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "Ch_updateCareProviderPayload",
    "kind": "LinkedField",
    "name": "ch_updateCareProvider",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "CareProvider",
        "kind": "LinkedField",
        "name": "careProvider",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useUpdateCareProviderMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useUpdateCareProviderMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "id": "cb4bde4176e81a91b3f1186c570e84aa",
    "metadata": {},
    "name": "useUpdateCareProviderMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "e60ea495eb8e449ba7ddbf00d19cfb60";

export default node;
